import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { QuoteItems } from "@tJohnstonCompanies/Handlers/RfqQuote/RfqQuoteNewState";
import { addQuoteDataFields, QuoteModel } from "@tJohnstonCompanies/Services/CustomRfqService";

type QuoteParameter = {
    CustomerOrderId?: string;
    QuoteCustomProductsList?: QuoteItems[];
    onSuccess?: () => void;
    onError?: (error: string, statusCode?: number) => void;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<QuoteParameter, QuoteModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    await addQuoteDataFields(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitQuoteData = createHandlerChainRunner(chain, "AddQuoteDataFields");
export default submitQuoteData;
